const priceWithCurrency = (value, store) => (
  `${store?.systemCountry === 'om' ? 'OMR' : 'AED'} ${value.toFixed(2)}`
);

export default priceWithCurrency;
